// extracted by mini-css-extract-plugin
export default {"container":"umG3Gx","accessibilityThemeContainer":"yNQ_Fi"};